import { useMe } from "@/api/queries/auth";
import { ClientPicker } from "@/components/clients/ClientPicker";
import { StatePage } from "@/components/states/StatePage";
import { useCambioDeCliente } from "@/hooks/useCambioDeCliente";
import { useRutaCliente } from "@/hooks/useRutaCliente";

interface NotFoundPageProps {
  /** Agencia con un slug que no está en sus clientes: se ofrece el selector abierto. La tienda nunca la ve. */
  variante?: "pagina" | "cliente";
}

/**
 * «No encontramos esta página.» (interaction.md §3). Para la tienda, un cliente ajeno se ve igual que
 * una página inexistente: nunca se revela que el cliente existe.
 */
export function NotFoundPage({ variante = "pagina" }: NotFoundPageProps) {
  const ruta = useRutaCliente();
  const { data: me } = useMe();
  const cambiar = useCambioDeCliente();

  if (variante === "cliente" && me?.principal.role === "agency") {
    return (
      <StatePage title="No encontramos este cliente." body="Elige uno de los tuyos.">
        <ClientPicker clients={me.clients} actualSlug={null} recientes={[]} onSelect={cambiar} />
      </StatePage>
    );
  }
  return <StatePage title="No encontramos esta página." action={{ to: ruta("inicio"), label: "Ir a Inicio" }} />;
}
